module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agePolicyAccepted) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('early-adopter-badge'), _vm._v(" "), _c('bug-reporter'), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "auth"
    }
  }), _vm._v(" "), (_vm.selectedLoader) ? _c('md-layout', {
    staticClass: "loader-wrapper"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "stroke-dasharray": "2 4",
      "stroke-dashoffset": "6",
      "d": "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dashoffset",
      "dur": "0.6s",
      "repeatCount": "indefinite",
      "values": "6;0"
    }
  })]), _c('path', {
    attrs: {
      "stroke-dasharray": "30",
      "stroke-dashoffset": "30",
      "d": "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.1s",
      "dur": "0.3s",
      "values": "30;0"
    }
  })]), _c('path', {
    attrs: {
      "stroke-dasharray": "10",
      "stroke-dashoffset": "10",
      "d": "M12 8v7.5"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.5s",
      "dur": "0.2s",
      "values": "10;0"
    }
  })]), _c('path', {
    attrs: {
      "stroke-dasharray": "6",
      "stroke-dashoffset": "6",
      "d": "M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.7s",
      "dur": "0.2s",
      "values": "6;0"
    }
  })])])])])]) : (_vm.selectedLoaderLogin) ? _c('md-layout', {
    staticClass: "loader-wrapper-login"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "stroke-dasharray": "2 4",
      "stroke-dashoffset": "6",
      "d": "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dashoffset",
      "dur": "0.6s",
      "repeatCount": "indefinite",
      "values": "6;0"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-dasharray": "30",
      "stroke-dashoffset": "30",
      "d": "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.1s",
      "dur": "0.3s",
      "values": "30;0"
    }
  })])])])])]) : _vm._e()], 1) : _c('div', {
    staticClass: "age_certify_policy_popup flex-container"
  }, [_c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('./assets/img/cuelistBLACK.png'),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h2', {
    staticClass: "md-headline"
  }, [_vm._v("An innovative, paperless tool that is reinventing"), _c('br'), _vm._v("collaboration for theater and live events")])]), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400",
      "letter-spacing": "0",
      "line-height": "22px",
      "text-align": "center"
    },
    attrs: {
      "md-flex": "100",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Cuelist is an excellent tool for professionals and students alike. But, in order to access Cuelist,"), _c('br'), _vm._v("you must be at least 13 years old. Please verify your age before proceeding.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    on: {
      "change": _vm.updateAgeCertifyPolicy
    },
    model: {
      value: (_vm.agePolicyAccepted),
      callback: function($$v) {
        _vm.agePolicyAccepted = $$v
      },
      expression: "agePolicyAccepted"
    }
  }, [_vm._v("I certify I am at least 13 years of age.")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cd0a8f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1276
// module chunks = 21